import React, { forwardRef } from 'react';
import { CnLoading } from '@/components/cn-loading';
import { useStyleOverrides } from '../../hooks/use-style-overrides';
const More = forwardRef((props, ref) => {
    const { moreRender, style } = props;
    const overrides = useStyleOverrides(props, 'scroll-view-more');
    const styledScrollViewMore = {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'font-size': 'var(--s-3)',
        'padding-top': 'var(--scroll-more-padding-top)',
        'padding-bottom': 'var(--scroll-more-padding-bottom)',
        color: 'var(--scroll-more-color)',
        ...style,
    };
    return (React.createElement("div", { ...props, ...overrides, style: styledScrollViewMore, ref: ref }, moreRender || React.createElement(CnLoading, { visible: true, size: "small" })));
});
export default More;
